import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-events-info',
  imports: [],
  templateUrl: './mdl-events-info.html',
  styleUrl: './mdl-events-info.css'
})
export class MdlEventsInfo {
  public events: any = [];
      
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.events = this.data.events;
  }

  getInitials(name: string): string {
    return name
      ?.split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2) || '??';
  }
}
